import { h, Component, cloneElement } from 'preact';
import style from './style';
import VideoPlayer from './../spareparts/videoplayer';

import { DEFAULT_WOOTAG_COLOR, loadJS, loadCSS, getMobileOS, getLinkedTagImage, addPixelImage, isSkipEnabled, isMiniature, debounce, handleExternalLinksViaClickThru, parseJsonToFormData } from '../helper';
import { constants, links } from '../config';
import SocialShareIcons from '../spareparts/socialShareIcons';
import SocialEmotionIcons from '../spareparts/socialEmotionIcons';
import PlayerLayout from '../playerLayout';
import SkinV3ProductShowcase from '../skinV3ProductShowcase';
import SkinV3MultiCta from '../skinV3MultiCta';
import IframeVideoContainer from '../spareparts/iframeVideo';
import MagazineGallery from '../spareparts/magazineGallery';

const HEAD = document.getElementsByTagName('head')[0];
const logo = 'https://www.geekchicelite.com/wp-content/uploads/2013/11/XboxOne_horizontal_rgb.png';
const skinEditorCanvasWidth = 586;
const skinEditorCanvasHeight = 328;
export default class ScreenController extends Component {
  constructor(props) {
    super(props);
    this.meta = this.props.json && this.props.json.meta;
    this.videoPlayer = [];
    this.skinmap = {
      tags: {},
      v1: 'skin_generic_banner', // skin without cta and title from json
      v2: 'skin_wootag_banner', // skin with cta and title from json
      v3: 'skin_cube',
      v4: 'skin_tags',
      launch0: 'regular',
      launch1: 'alwayson',
      launch2: 'skip',
    };

    this.tagParams = {};

    if (this.meta.skin_tag_object) {
      this.meta.skin_tag_object.forEach((item) => {
        this.tagParams[item.tagid] = item;
      });
    }

    this.custom = this.props.json.custom;
    this.customEndCardsData = this.custom && this.custom.endcards;
    this.customEndCardEnabled = this.customEndCardsData && this.customEndCardsData.customEndCard;

    this.customSkinData = this.custom && this.custom.customskin;
    this.customSkinDataEnabled = this.customSkinData && this.customSkinData.enableSkin;
    this.customSkinApplicableForAll = this.customSkinDataEnabled && this.customSkinData.applicalbleForAll;
    this.customSkinTagsData = this.customSkinDataEnabled && this.customSkinData.tagsAttribute || [];

    this.meta.skins = this.meta.skins || this.customSkinDataEnabled;
    if (this.customSkinTagsData.length > 0) {
      this.meta.skin_tag_object = [];

      this.customSkinTagsData.forEach(item => {
        const exitstingData = this.tagParams[item.id] || {};
        const skinVersionMap = {
          generic: 'v1',
          wootag: 'v2',
          cube: 'v3',
          tag: 'v4',
        }
        const skinLaunchMap = {
          regular: 0,
          alwaysOn: 1,
          skip: 2,
        }

        const customMappingToAB = {
          ...item,
          tagid: item.id,
          theme: item.theme === 'dark' ? 'skins_dark_theme' : 'skins_light_theme',
          bg_overlay_percentage: item.overlayOpacity,
          skin_version: skinVersionMap[item.template],
          skin_launch: skinLaunchMap[item.launch],
        }
        this.tagParams[item.id] = { ...exitstingData, ...customMappingToAB };
        this.meta.skin_tag_object.push(this.tagParams[item.id]);
      });
    }

    this.state = {
      activeIndex: 0,
      brandBar: this.meta && this.meta.brand_bar,
      enableCube: false,
      isSquareVideo: false,
      layoutEnabled: false,
      layout: this.getSkinLayout(),
      scaleOut: false,
      startedToPlay: false,
      showCustomEndCard: false,
      hotspotLinkedTag: null,
      progressOverlayImageLinkedTag: null,
      overlayImageLinkedTagIsExpanded: false,
      overlayImageLinkedTagIsActiveSlide: false,
      mapsApiLoaded: false,
      showTileProducts: false,
      tileDimensionClass: '',
      tileProducts: [],
      tileLinkedTag: null,
      animateInTiles: '',
      animateTileNav: false,
      animateScreenShrink: false,
      slideTileHeight: false,
      currentTileIndex: 0,
      initializeConnectedVideo: null,
      closeSkinMode: false,
      collectionsVideoActiveIdxMap: {},
      isSkinSliderActive: false,
      skinSliderConfiguration: null,
      animateInSkinSliderId: 0,
      skipDuration: this.props.creativeData && this.props.creativeData.skip_offset,
      showCollectionsMagazine: false,
      videoEnded: false,
    };
  }

  componentWillUnmount() {
    if (this.swiperTile) {
      this.swiperTile.destroy();
      window.removeEventListener('resize', debounce(this.handleResize, 250));
    }
    if (this.isCustomProportionsResizeEventListenerAdded) {
      window.removeEventListener('resize', debounce(this.handleCustomProportionsWhenResize, 250));
    }
  }

  componentDidMount() {
    if (this.customEndCardEnabled) {
      import(
        /* webpackChunkName: "chunk-customEndCards" */
        `./../spareparts/customEndCards`
      ).then((res) => {
        this.setState({
          customEndCardsLoaded: true,
          customEndCards: res,
        });
      });
    }

    if (this.meta.scratch) {
      import(
        /* webpackChunkName: "chunk-scratch" */
        `./../scratch`
      ).then((res) => {
        this.setState({
          scratchLoaded: true,
          scratchModule: res,
        }, () => {
          if (this.meta.scratchTimeoutDelay && this.meta.scratchTimeoutDelay > 0) {
            this.scratchTimeout = setTimeout(() => {this.setState({
              scratchUnload: true
            })}, this.meta.scratchTimeoutDelay*1000);
          }
        });
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const tag = this.state.tag;
    const tagParams = tag && this.tagParams[tag.id];
    const skinVersion = tagParams && tagParams.skin_version;

    /** if collections video swiper needed, for now we will just load the videos directly */
    /* const subcategory = tag && tag.settings && tag.settings.subcategory && tag.settings.subcategory[0] && tag.settings.subcategory[0];
  const subcategoryType = subcategory && subcategory.type;
    const isCollectionsVideo = subcategoryType === 107; // CHANGE IT TO 107
    */
   const isCollectionsVideo = false;

    if ((this.meta && skinVersion === 'v3' || isCollectionsVideo) && !this.swiper) {
      if (!window.Swiper) {
        this.loadSwiperJS = loadJS(links.swiperJS, HEAD);
        this.loadSwiperCSS = loadCSS(links.swiperCSS, HEAD);

        Promise.all([this.loadSwiperJS, this.loadSwiperCSS]).then((res) => {
          this.initializeSlider();
        });
      } else this.initializeSlider();
    }

    const isTileThemeEnabled = this.isTileThemeEnabled(prevProps.json.tags);
    if (isTileThemeEnabled && !this.swiperTile) {
      if (!window.Swiper) {
        this.loadSwiperJS = loadJS(links.swiperJS, HEAD);
        this.loadSwiperCSS = loadCSS(links.swiperCSS, HEAD);

        Promise.all([this.loadSwiperJS, this.loadSwiperCSS]).then((res) => {
          this.setState({ swiperJsTile: true }, () => {
            this.initializeSliderTile();
          });
        });
      } else {
        this.setState({ swiperJsTile: true }, () => {
          this.initializeSliderTile();
        });
      }
      window.addEventListener('resize', debounce(this.handleResize, 250));
    }

    if (this.meta && skinVersion === 'v3') {
      if (this.state.imageCount !== prevState.imageCount) {
        this.imageCount = this.state.imageCount;
        this.swiper && this.swiper.update();
      }

      this.setTranslate(prevState);
    }

    if (this.meta && skinVersion === 'v4') {
      const playerWrapper = this.props.playerWrapper;
      playerWrapper && playerWrapper.classList.add('removeOTT');
    }

    if (this.state.tag) {
      if ((prevState.tag && this.state.tag.id !== prevState.tag.id) || (!prevState.tag && this.state.tag.id)) {
        this.setState({
          layout: this.getSkinLayout(),
        });
        if (this.state.tag.details && this.state.tag.details.customTheme === 'magazine') {
          this.setState({
            showCollectionsMagazine: true,
          })
        }
      }
    }

    const customProportions = tagParams && tagParams.config && tagParams.config.customProportions && tagParams.config.customProportions;

    if (customProportions && customProportions.isEnabled) {
      this.isCustomProportionsResizeEventListenerAdded = true;
      window.addEventListener('resize', debounce(this.handleCustomProportionsWhenResize, 250));
    }

    if (this.props.creativeData && this.props.creativeData.skip_offset && prevProps.creativeData && this.props.creativeData.skip_offset !== prevProps.creativeData.skip_offset) {
      this.setState({ skipDuration: this.props.creativeData && this.props.creativeData.skip_offset });
    }
  }

  handleAdSkip = (e) => {
    e && e.stopPropagation();
    window.vpaid && window.vpaid.stopAd();
  };

  setElapsedTime = (elapsedTime) => {
    if (this.state.skipDuration && this.props.isAd) {
      this.setState({ elapsedTime: Math.round(elapsedTime) });
    }
  }

  render(props, state) {
    let meta = this.meta;
    let tag = state.tag;
    let color = (tag && tag.details.color) || DEFAULT_WOOTAG_COLOR;
    let title = tag && tag.details.title;
    let cta = state.cta;
    // Custom Skin---
    const tagParams = this.tagParams && this.tagParams[tag && tag.id];
    const customSkinImages = tagParams && tagParams.image && JSON.parse(tagParams.image);
    const customSkinImage = customSkinImages && getLinkedTagImage({ images: customSkinImages }, null, null, null, true);
    const currTagId = tag && tag.id;
    const currTagCustomSkinData = currTagId && this.customSkinTagsData.find(t => t.id === currTagId);
    if (currTagCustomSkinData) {
      this.meta.skin_orientation = currTagCustomSkinData.align === 'middle' ? 'center' : currTagCustomSkinData.align;
    }
    const customSkinType = this.customSkinData && this.customSkinData.skinType;
    const isProductShowcaseSkin = customSkinType && customSkinType === 'productShowcase';
    const isMultiCtaSkin = customSkinType && customSkinType === 'multiCta';
    const useTagImage = !isProductShowcaseSkin && !isMultiCtaSkin;
    //---
    const currTagIdx = tag && this.props.json.otags.findIndex(t => t.id === tag.id);

    let preLoadImgIdx = 0;
    let currTagImg = '';
    if (typeof currTagIdx === 'number') {
      preLoadImgIdx = currTagIdx + 1 < this.props.json.otags.length ? currTagIdx + 1 : 0;
      currTagImg = meta && meta.skins && (customSkinImage || (useTagImage ? this.getImage(this.props.orientation, this.props.json.otags[currTagIdx]) : ''));
    }
    const nextTag = this.props.json.otags[preLoadImgIdx];
    const nextCustomSkinTagData = this.tagParams && this.tagParams[nextTag && nextTag.id];
    const nextCustomSkinImages = nextCustomSkinTagData && nextCustomSkinTagData.image && JSON.parse(nextCustomSkinTagData.image);
    const nextCustomSkinImage = nextCustomSkinImages && getLinkedTagImage({ images: nextCustomSkinImages }, null, null, null, true);
    const preloadBgImg = meta && meta.skins && (nextCustomSkinImage || (useTagImage ? this.getImage(this.props.orientation, nextTag) : ''));
    let image = currTagImg || (useTagImage ? state.image : '');
    let images = state.images;
    let imageCount = state.imageCount;
    let hideCta = meta && meta.showcase_tag_cta;

    const customSkinBgColor = tagParams && tagParams.backgroundColor;
    const customSkinOverlayImages = tagParams && tagParams.overlayImage && JSON.parse(tagParams.overlayImage);
    const overlayImage = customSkinOverlayImages && getLinkedTagImage({ images: customSkinOverlayImages }, null, null, null, true);

    const nextCustomSkinOverlayImages = nextCustomSkinTagData && nextCustomSkinTagData.overlayImage && JSON.parse(nextCustomSkinTagData.overlayImage);
    const nextCustomSkinOverlayImage = nextCustomSkinOverlayImages && getLinkedTagImage({ images: nextCustomSkinOverlayImages }, null, null, null, true);
    const preloadOverlayImg = meta && meta.skins && (nextCustomSkinOverlayImage || '');

    const orientation = this.customSkinData && this.customSkinData.skinOrientation || 'horizontal';
    const skinHotspots = tagParams && tagParams.hotspots || [];
    let skinHotspotSliders = [];
    if (tagParams && tagParams.hotspots && tagParams.hotspots.some(ht => ht.enableOnSkinSlider)) {
      skinHotspotSliders = tagParams.hotspots.filter(ht => ht.enableOnSkinSlider)
    }
    // console.log(skinHotspots)
    const category = tag && tag.settings.category;
    const subcategory =
      category && tag.settings.subcategory && tag.settings.subcategory[0] && tag.settings.subcategory[0];
    const subcategoryType = subcategory && subcategory.type;

    let skinConnectedAssets = [];
    if (tagParams && tagParams.gridLayoutForConnectedAssets && this.meta && this.meta.skin_orientation !== 'center') {
      const isDPTagSelectedWithVideoEnabled = tag && tag.details && tag.details.engagements && tag.details.engagements[0] && tag.details.engagements[0].native_video;
      if (category === 15 && isDPTagSelectedWithVideoEnabled) {
        // dp tag
        skinConnectedAssets = tag && tag.details && tag.details.engagements && tag.details.engagements[0] && tag.details.engagements[0].meta && tag.details.engagements[0].meta.map(m => { return { type: m.type, sourceCat: category, imgUrl: m.url, id: m.videoId, description: m.description, cltTracker: m.cltTracker } });
      }
    }
    // console.log({tagParams})
    const skinVersion = tagParams && tagParams.skin_version;
    const enableSkinsV2 = tagParams && tagParams.skin_version === 'v4' ? `skinsV2 tag${subcategoryType}` : '';
    const noBackground = tagParams && tagParams.transparent ? 'noBackground' : '';
    const isPortraitVideoInLandscape =
      props.portraitVideo && props.orientation === constants.ORIENTATION_LANDSCAPE
        ? `portraitVideoInLandscape ${state.layoutEnabled ? state.layout : ''}`
        : '';
    const skinsBgOverlay = tagParams && tagParams.bg_overlay_percentage;

    const skinOrientation = this.meta && this.meta.skin_orientation;
    let portraitVidAlignClass = '';
    if (skinOrientation === 'top') {
      portraitVidAlignClass = 'vidTOP';
    } else if (skinOrientation === 'bottom') {
      portraitVidAlignClass = 'vidBOTTOM';
    }

    const tagStatus = this.state.image ? 'tagPresent' : 'tagAbsent';
    const isLayoutEnabled = state.layoutEnabled ? 'enable' : '';
    const isSquareVideo = state.isSquareVideo ? 'squareVideo' : '';
    const isPortraitVideo = this.props.portraitVideo ? 'portraitVideo' : '';

    const customSkinTagVideoSize = tagParams && tagParams.size;
    const videoSize = this.meta && this.meta.skins && (customSkinTagVideoSize || this.meta.video_size || '').toLowerCase();
    let vidSizeClass = '';
    if (videoSize === 'small') {
      vidSizeClass = 'vidSizeSmall';
    } else if (videoSize === 'medium') {
      vidSizeClass = 'vidSizeMedium';
    }else if (videoSize === 'large') {
      vidSizeClass = 'vidSizeLarge';
    }

    const isEditorMode = props.editorMode ? 'editorMode' : '';

    let portraitWithTagOpened = '';
    if (this.props.isMobileDevice && this.props.orientation === constants.ORIENTATION_PORTRAIT && this.state.progressOverlayImageLinkedTag) {
      portraitWithTagOpened = 'portraitWithTagOpened';
    }
    const screenHasTiles = state.showTileProducts ? 'screenHasTiles' : '';
    const tileProductsClassName = state.showTileProducts ? ` showTileProductsWithScreen ${state.tileDimensionClass} ` : '';

    let screenControllerClass = `screenController ${enableSkinsV2} ${noBackground} ${tagStatus} ${isLayoutEnabled} ${isSquareVideo} ${isPortraitVideo} ${isPortraitVideoInLandscape} ${portraitVidAlignClass} ${isEditorMode} ${portraitWithTagOpened}`;
    let screen = cloneElement(props.children[0], {
      ...props,
      triggerSkinLayout: this.meta && this.meta.skin_tag_object ? this.triggerSkinLayoutV2 : this.triggerSkinLayout,
      handlePlay: this.handlePlay,
      setTagInScreenController: this.setTagInScreenController,
      setSquareVideo: this.setSquareVideo,
      cusotmEndCardEnabled: this.state.customEndCardsLoaded,
      showCustomEndcards: this.toggleCustomEndcards,
      showProgressOverlayImageLinkedTag: this.toggleProgressOverlayImageLinkedTag,
      setActiveIndexForImageGallery: this.props.setActiveIndexForImageGallery,
      toggleTileProducts: this.toggleTileProducts,
      setElapsedTime: this.setElapsedTime,
      setVideoEnded: this.setVideoEnded,
    });

    const isSkinV2 = tag && this.meta && this.meta.skin_version === 'v2';
    const socialTag = state.isSocialShare || state.isSocialEmotion;
    let screenHandleSocialClass = isSkinV2 && socialTag ? 'middleUp' : '';
    if (tag && tag.emojiSelected && isSkinV2) {
      screenHandleSocialClass = 'middleUp enlarge';
    }

    const CustomEndCards = this.state.customEndCardsLoaded
      ? this.state.customEndCards && this.state.customEndCards.default
      : null;

    const ScratchOff = this.state.scratchLoaded ? this.state.scratchModule && this.state.scratchModule.default : null;
    const animate = tagParams && tagParams.animate || this.meta && this.meta.animate_transition;
    const isVertical = ['top', 'bottom', 'middle'].includes(tagParams && tagParams.align);
    let multiCtaStyle = isMultiCtaSkin ? 'multiCtaSkin' : '';
    if (isVertical) {
      multiCtaStyle += ' vertical';
    }

    const isTileThemeEnabled = this.isTileThemeEnabled(props.json.tags);
    const isCollectionsVideo = subcategoryType === 107; // CHANGE IT TO 107
    const collectionsVideos = isCollectionsVideo ? tag && tag.details && tag.details.attributes : null;
    screenControllerClass = `${screenControllerClass} ${isCollectionsVideo ? 'collections-videos' : ''}`;
    const activeProdVideoIdx = this.state.collectionsVideoActiveIdxMap[tag && tag.id];

    const enableSkip = this.state.skipDuration && this.state.skipDuration - this.state.elapsedTime > 0;
    const activeSignalRuleValue = tag && tag.activeSignalRuleValue;
    const tagidClass = `tagid_${tag && tag.id}`;
    return (
      <div
        class={screenControllerClass}
      >
        <div class='preloadBg' style={{ background: skinVersion !== 'v3' && preloadBgImg ? `url(${preloadBgImg})` : `none` }}/>
        <div class="skinBgColor" style={customSkinBgColor ? { backgroundColor: customSkinBgColor }: { display: 'none' }}/>
        <div class='skinBg' style={{ background: skinVersion !== 'v3' && image ? `url(${image})` : `none` }}/>
        <div class='preloadOverlay' style={{ background: skinVersion !== 'v3' && preloadOverlayImg ? `url(${preloadOverlayImg})` : `none` }}/>
        {!this.meta.scratch && <div class='skinOverlayBg' style={{ background: skinVersion !== 'v3' && overlayImage ? `url(${overlayImage})` : `none` }}/>}
        {this.meta.scratch && overlayImage && !this.state.unloadScratch && <ScratchOff unload={this.state.scratchUnload} ready={this.scratchReady} cover={overlayImage} callback={this.scratchDone} start={this.scratchStart} fireEvent={this.scratchClickEvent} />}
        <div
          class={'screenControllerBg'}
          onClick={this.handleImageClick}
          style={{
            background: `rgba(0,0,0,${skinsBgOverlay ? skinsBgOverlay / 100 : 0})`,
          }}
        />
        {skinConnectedAssets.length > 0 && <div class={`skinConnectedAssetsWrapper ${this.getSkinConnectedAssetsLayoutClasses(videoSize)} scawHas_${skinConnectedAssets.length > 4 ? 'Many' : skinConnectedAssets.length} ${tagidClass}`}>
          {skinConnectedAssets.map(item => {
            const { type, sourceCat, imgUrl, id, description, cltTracker } = item;
            return (
              <div key={id} class={`connectedAssetLayout`} onClick={() => this.handleSkinConnectedAssetClick(type, sourceCat, id, cltTracker)} style={{ background: `url(${imgUrl})` }}>
                <div class={'play-icon-container'}>
                  <i class={'zmdi zmdi-play-circle-outline'} />
                </div>
                <div className={`connectedAssetLabel`} dangerouslySetInnerHTML={{__html: description}} />
              </div>
            );
          })}
        </div>}
        {state.initializeConnectedVideo && <div class={`closeSkinConnectedVideoWrapper ${this.meta && this.meta.skin_orientation === 'left' ? 'closeSkinConnectedLeft' : ''}`} onClick={this.handleSkinConnectedAssetClose}><i class={'zmdi zmdi-close'} /></div>}
        {state.initializeConnectedVideo && <div class={`skinConnectedVideoWrapper ${this.getSkinConnectedAssetsLayoutClasses(videoSize, true)} ${tagidClass}`}>
          <IframeVideoContainer video={{ videoId: state.initializeConnectedVideo }} domain={props.adUnitSrv} />
        </div>}
        <div class='hotspotsWrapper'>
          {skinHotspots.map(item => {
            const { x, y, width, height, id, url, tagId } = item;
            const { ctaAnimationType, ctaAnimateForever, ctaBgColor, ctaBorderRadius, ctaText, ctaTextColor, ctaType, ctaImage, enableCta } = item;
            const {enableOnSkinSlider, onSkinSliderCtaLink} = item;
            if (!url && !tagId && enableOnSkinSlider && !onSkinSliderCtaLink){
              return null;
            }
            const canvasWidth = orientation === 'vertical' ? skinEditorCanvasHeight : skinEditorCanvasWidth;
            const canvasHeight = orientation === 'vertical' ? skinEditorCanvasWidth : skinEditorCanvasHeight;
            const widthRatio = window.innerWidth/canvasWidth;
            const heightRatio = window.innerHeight/canvasHeight;
            const updatedWidth = widthRatio * width;
            const updatedHeight = heightRatio * height;
            const updatedX = widthRatio * x;
            const updatedY = heightRatio * y;
            const hotspotStyle = { width: updatedWidth, height: updatedHeight, top: updatedY, left: updatedX, position: 'absolute' };
            let hasChildComponent = false;
            let imageSrc = false;
            let animationStyle = '';
            if (enableOnSkinSlider) {
              hasChildComponent = 'hotspot';
            } else if (enableCta) {
              animationStyle = ctaAnimationType || '';
              if (ctaType === 'custom') {
                if (ctaText) hasChildComponent = 'text';
              } else {      // default -> ctaType = 'image'
                if (Object.keys(ctaImage).length > 0) {
                  hasChildComponent = 'image';
                  imageSrc = ctaImage[Object.keys(ctaImage)[0]].src;
                }
              }
            }
            return (
              <div key={id} style={hotspotStyle} onClick={() => this.handleSkinHotspotClick(item)}>
                {hasChildComponent === 'text' && <div class={`${animationStyle} ${ctaAnimateForever ? 'run-forever' : ''}`} style={{
                  width: '100%',
                  height: '100%',
                  backgroundColor: ctaBgColor || '#3cb1e6',
                  borderRadius: ctaBorderRadius,
                  color: ctaTextColor || '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>{ctaText}</div>}
                {hasChildComponent === 'hotspot' && <div class={`hotspotPulsateContainer`}><div class={`hotspotPulsate`}/></div>}
                {hasChildComponent === 'image' && imageSrc && <img alt="" class={`hotspotCtaImage ${animationStyle} ${ctaAnimateForever ? 'run-forever' : ''}`} src={imageSrc} />}
              </div>
            )
          })}
        </div>
        <div className={`skinSliderWrapper`}>
          {skinHotspotSliders.length > 0 && skinHotspotSliders.map(skinHotspotSlider => {
            const imageSrc = skinHotspotSlider.onSkinSliderImage[Object.keys(skinHotspotSlider.onSkinSliderImage)[0]].src;
            return (
              <div class={`skinSliderContainer ${state.animateInSkinSliderId === skinHotspotSlider.id ? 'animateInSkinSlider' : ''} ${this.getSkinSliderLayoutClasses(videoSize)}`} style={{
                backgroundImage: `url(${imageSrc})`,
              }}
              onClick={() => {this.handleSkinSliderClick(skinHotspotSlider)}}
              >
                <div class={`skinSlidercloseBtnContainer`} onClick={this.handleSkinSliderCloseClick}><i class="zmdi zmdi-close"/></div>
                {skinHotspotSlider.onSkinSliderCtaText && <div class={`skinSliderCtaContainer`} style={{backgroundColor: skinHotspotSlider.onSkinSliderCtaBgColor || '#3cb1e6'}}><span style={{color: skinHotspotSlider.onSkinSliderCtaTextColor || '#ffffff'}} dangerouslySetInnerHTML={{ __html: skinHotspotSlider.onSkinSliderCtaText }} /></div>}
              </div>
            );
          })
          }
        </div>
        <div
          ref={(c) => (this.screenHandleRef = c)}
          class={`screenHandle ${this.meta.scratch ? 'fullscreenVideo' : ''} ${vidSizeClass} ${animate ? 'animate' : ''} ${state.layoutEnabled ? state.layout : ''} ${
            state.scaleOut ? 'scaleOut' : ''
            } ${screenHandleSocialClass} ${multiCtaStyle} ${tileProductsClassName} ${skinVersion === 'v3' ? 'skincube' : ''}`}
          style={
            state.layoutEnabled && props.portraitVideo
              ? props.orientation === constants.ORIENTATION_LANDSCAPE
                ? {
                    width: state.isSquareVideo ? window.innerWidth / 2 : 0.5625 * window.innerHeight,
                    height: state.isSquareVideo ? window.innerWidth / 2 : window.innerHeight,
                  }
                : {
                    width: state.isSquareVideo ? window.innerWidth : 0.5625 * window.innerHeight,
                    height: state.isSquareVideo ? window.innerWidth : window.innerHeight,
                  }
              : state.showCollectionsMagazine ? {overflow: 'visible'} : {}
          }
        >
          {this.meta && skinVersion === 'v3' ? (
            <div ref={(c) => (this.swiperContainer = c)} class={'swiper-container'}>
              <div
                class={`swiper-wrapper ${state.disableAnimation ? 'disable-anim' : ''}`}
                ref={(c) => (this.swiperWrapper = c)}
              >
                <div class={`swiper-slide`}>{screen}</div>
                {imageCount &&
                  Array.apply(0, Array(imageCount)).map((item, index) => {
                    let hideFooter = state.isShowcase && hideCta ? 'hide-footer' : '';
                    let getImage = this.getImageIndex(images, index);
                    let image = state.isShowcase ? getImage.url : getImage;
                    title = state.isShowcase ? getImage.description : title;
                    cta = state.isShowcase ? getImage.ctaLabel : cta;

                    return (
                      <div class={`swiper-slide`}>
                        {state.isShowcase && getImage.type === 'video' ? (
                          <VideoPlayer
                            ref={(c) => (this.videoPlayer[index] = c)}
                            eventBus={props.eventBus}
                            index={index}
                            item={getImage}
                            tag={state.tag}
                            videoId={props.videoId}
                            isMuted
                            handleVideoEvent={() => {}}
                          />
                        ) : (
                          <div
                            class={'fsImage'}
                            style={{ background: `url(${image})` }}
                            onClick={state.isShowcase ? this.handleShowcaseLink.bind(this, getImage) : null}
                          />
                        )}

                        <div
                          class={`tag-details-wrapper ${state.layout} ${hideFooter} ${
                            state.isShowcase ? 'showcase' : ''
                          }`}
                          style={{ backgroundColor: color }}
                        >
                          <h2 class={'tag-details-title'}>{title}</h2>
                          <div class={'tag-details-cta'}>
                            <button
                              class={'tag-details-cta-button'}
                              style={{ background: color }}
                              onClick={
                                state.isShowcase ? this.handleShowcaseLink.bind(this, getImage) : this.proxyClickHandler
                              }
                            >
                              {cta}
                            </button>
                            <i class={'zmdi zmdi-arrow-right'}></i>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>

              <div class={`ottBottomNavi ${!state.startedToPlay ? 'hide' : ''}`}>
                <div
                  class={'swiper-button-left zmdi'}
                  ref={(a) => (this.swiperNaviLeft = a)}
                  onClick={this.prevSlide}
                ></div>
                <div
                  class={'swiper-button-right zmdi'}
                  ref={(b) => (this.swiperNaviRight = b)}
                  style={{ right: -window.innerWidth }}
                  onClick={this.nextSlide}
                ></div>
              </div>
            </div>
          ) : isTileThemeEnabled ? (
            <div ref={(c) => (this.swiperContainerTile = c)} class={`swiper-container swiper-tile-container ${screenHasTiles}`}>
              <div
                class={`swiper-wrapper ${state.disableAnimation ? 'disable-anim' : ''}`}
                ref={(c) => (this.swiperWrapperTile = c)}
              >
                <div class={`swiper-slide ${state.animateScreenShrink ? 'animateScreenShrink' : ''}`}>
                  {screen}
                  {state.animateScreenShrink && <div class="tempScreenPlaceholder"></div>}
                    {!isMiniature() && state.showTileProducts && state.tileProducts && state.tileProducts.length > 0 && state.tileProducts.slice(0, 3).map((product, i) => {
                      return (<div class={`tileProductContainer ${state.animateInTiles} ${state.tileDimensionClass} animateTile${i + 1}`}
                      key={product.id}
                      id={product.id}
                      onClick={(e) => this.handleTileClick(e)}
                      style={state.slideTileHeight && { height: state.slideTileHeight }}
                    >
                      <img src={product.img1_src} alt="" class="tileProductImage" />
                    </div>);
                  })}
                </div>
                {(() => {
                  const groupSize = isMiniature() ? 1 : 4;
                  const startingIndex = isMiniature() ? 0 : 3;
                  if (state.showTileProducts && state.tileProducts && state.tileProducts.length > startingIndex) {
                    const tileSlides = state.tileProducts.slice(startingIndex).map((product) => {
                      return (<div class={`tileProductContainer ${state.animateInTiles} ${state.tileDimensionClass}`}
                        key={product.id}
                        id={product.id}
                        onClick={(e) => this.handleTileClick(e)}
                        style={state.slideTileHeight && { height: state.slideTileHeight }}
                      >
                        <img src={product.img1_src} alt="" class="tileProductImage" />
                      </div>);
                    }).reduce(function (r, element, index) {
                      // create element groups with size 4, result looks like:
                      // [[elem1, elem2, elem3, elem4], [elem5, elem6, ...], ...]
                      index % groupSize === 0 && r.push([]);
                      r[r.length - 1].push(element);
                      return r;
                    }, []).map(function (rowContent) {
                      // surround every group with 'swiper-slide'
                      return <div class="swiper-slide">{rowContent}</div>;
                    });
                    return tileSlides;
                  }
                })()}
              </div>
              {state.showTileProducts && <div class="tile-group-pagination-controls">
                <div class={`tile-group-paginate ${this.state.isBeginningTile ? '' : 'show-nav-btn'} ${this.state.animateTileNav ? 'goto-prev-product' : ''}`} onClick={this.prevTileGroup} ref={(a) => (this.swiperNaviLeftTileGroup = a)}><i class={'zmdi zmdi-arrow-left'} /></div>
                <div class={`tile-group-paginate ${this.state.isEndTile ? '' : 'show-nav-btn'} ${this.state.animateTileNav ? 'goto-next-product' : ''}`} onClick={this.nextTileGroup} ref={(b) => (this.swiperNaviRightTileGroup = b)}><i class={'zmdi zmdi-arrow-right'} /></div>
              </div>}
              {state.showTileProducts && <div class="closeTag" onClick={() => this.toggleTileProducts(false, null, [])}><i class="zmdi zmdi-close"></i></div>}
            </div>
          ) : (
            screen
          )}
          {this.state.showCollectionsMagazine && !this.state.videoEnded && <div class="collection-magazine">
            {this.renderCollectionsMagazine()}
          </div>}
          {this.meta && skinVersion === 'v3' && state.startedToPlay && state.activeIndex !== 0 ? (
            <div class={'swiper-slide-custom-button'} onClick={this.handleGoBackToVideo}>
              <i class={'zmdi zmdi-arrow-back'}></i>
              <span>{'Go to Video'}</span>
            </div>
          ) : null}
          {
            isCollectionsVideo && <div ref={(c) => (this.swiperContainer = c)} class={'swiper-container collections-video-swiper-container'}>
              <div
                class={`swiper-wrapper ${state.disableAnimation ? 'disable-anim' : ''}`}
                ref={(c) => (this.swiperWrapper = c)}
              >
                {collectionsVideos &&
                  collectionsVideos.map((item, index) => {
                    let settingsEngagement = subcategory && subcategory.engagements && subcategory.engagements[0];
                    let ctaLabel = settingsEngagement && settingsEngagement[`label|${settingsEngagement.slug}`];
                    const colWhite = item.details.color && ['white', '#fff', '#ffffff'].includes(item.details.color);
                    let eventData = {};
                    if (item && item.details) {
                      eventData = { engagementLabel: item.details.title, engagementId: item.id, };
                    }
                    return (
                      <div class={`swiper-slide ${index === activeProdVideoIdx ? 'active': ''}`}>
                        <VideoPlayer
                          ref={(c) => (this.videoPlayer[index] = c)}
                          eventBus={props.eventBus}
                          index={index}
                          item={item.video}
                          tag={tag}
                          videoId={props.videoId}
                          isMuted
                          autoplay={index === activeProdVideoIdx}
                          handleVideoEvent={() => {}}
                          hideControls
                          eventData={eventData}
                        />
                        <div class='collections-video-footer'>
                          <div class='title'>{item.details.title}</div>
                          <div class='cta' style={{ backgroundColor: item.details.color, color: colWhite ? 'black': 'white' }} dangerouslySetInnerHTML={{ __html: ctaLabel }} onClick={() => this.handleProdCtaClick(item)} />
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          }
          {
            isCollectionsVideo && collectionsVideos && <div class={`collections-video-prod-thumb ${collectionsVideos.length > 5 ? 'scrollable' : ''}`}>
              {collectionsVideos.map((item, idx) => {
                const itemImg = item && item.media && (item.media.img1_120 && !item.media.img1_120.toLowerCase().endsWith('.gif') ? item.media.img1_120 : item.media.img1_src);
                const col = item && item.details && item.details.color;
                return <div key={item && item.details && item.details.title} style={{ backgroundColor: col }} class={idx === activeProdVideoIdx ? 'active' : ''} onClick={() => this.handleActiveProdVideo(idx)}>{itemImg ? <img src={itemImg} alt={item && item.details && item.details.title} /> : null}</div>
              })}
            </div>
          }
        </div>

        {tag && this.meta && skinVersion === 'v1' && isProductShowcaseSkin && state.layoutEnabled && this.renderProductShowcase({tag, orientation: skinOrientation, tagParams})}
        {tag && this.meta && skinVersion === 'v1' && isMultiCtaSkin && state.layoutEnabled && this.renderMultiCta({tag, orientation: skinOrientation, tagParams})}

        {tag && this.meta && skinVersion === 'v2' && this.renderV2(color, title, cta)}

        {tagParams && enableSkinsV2 && this.renderTag()}
        <div class="activeSignalRuleValue" style={{ transform: `scale(${window.innerWidth/1008})` }}>{activeSignalRuleValue && activeSignalRuleValue.map(item => {
          return (
            <div id={`rule_${item.id}`} key={item.id}>{item.val}</div>
          )
        })}</div>
        {state.brandBar ? (
          <div class={'brandbar'}>
            <div class={'logo-placeholder'} style={{ background: `url(${logo})` }} />
          </div>
        ) : null}

        {socialTag && cta && state.ctaValue && (
          <div class={'wt-social-cta'} onClick={this.proxyClickHandler}>
            {cta}
          </div>
        )}
        {this.state.showCustomEndCard && (
          <CustomEndCards
            cards={this.customEndCardsData.customEndCards}
            handleReplay={this.handleReplay}
            skinTag={true}
            keyIndex={0}
            index={0}
            tags={props.tags}
            json={props.json}
            updateMerchantData={props.updateMerchantData}
            isAd={props.isAd}
            adUnits={props.adUnits}
            adUnitsArgs={props.adUnitsArgs}
            adType={props.adType}
            adUnitSrv={props.adUnitSrv}
            creativeData={props.creativeData}
            initAd={props.initAd}
            lsCards={props.lsCards}
            eventBus={props.eventBus}
            decisionPointSelector={state.decisionPointSelector}
            ottRect={props.ottRect}
            videoId={props.videoId}
            videoWidth={props.videoWidth}
            videoHeight={props.videoHeight}
            isActiveSlide={true}
            isExpanded={true}
            isLandscape={props.orientation === constants.ORIENTATION_LANDSCAPE}
            isMobileDevice={props.isMobileDevice}
            editorMode={props.editorMode}
            orientation={props.orientation}
            template={props.json.template}
            toggleModal={props.toggleModal}
            activateTag={props.activateTag}
            deactivateTag={props.deactivateTag}
            getCurrentTime={props.getCurrentTime}
            destroyTag={props.destroyTag}
            logDataEvent={props.logDataEvent}
            logPollOption={props.logPollOption}
            fetchRedeemCode={props.fetchRedeemCode}
            isFacebookAd={props.isFacebookAd}
            mapsapi={props.mapsApiLoaded}
            handleChapterSelect={props.handleChapterSelect}
            trackEvent={props.trackEvent}
            noVideo={props.noVideo}
            forceStart={props.forceStart}
            decisionClose={props.decisionClose}
            postMessage={props.postMessage}
            dpTagActive={state.dpTagActive}
            setDecisionCloseFalse={props.setDecisionCloseFalse}
            handleAutoPauseException={props.handleAutoPauseException}
            shouldDeactivateTag={props.deactivateTag}
            renderLandscapeCards={props.renderLandscapeCards}
            setTagAutoInteraction={props.setTagAutoInteraction}
            setFullWidthOTT={props.setFullWidthOTT}
            tagAutoInteraction={props.tagAutoInteraction}
            hasDirectTag={props.hasDirectTag}
            updateJsonTag={props.updateJsonTag}
            pauseVideo={props.pauseVideo}
            playVideo={props.playVideo}
          />
        )}
        {this.state.hotspotLinkedTag ? (
          <div class={'ottWrapper enable expand'}>
            <div class={'ottContainer'}>
              <div class={'ottTemplate'}>
                <div class={'passive-tag-container skin-passive-container'}>
                  <PlayerLayout {...props} tags={props.json && props.json.otags} tag={this.state.hotspotLinkedTag} isDecisionInput deactivateTag={this.deactivateHotspotTag} isExpanded mapsapi={state.mapsApiLoaded}/>
                </div>
              </div>
            </div>
          </div>
        ) : null}
        {this.state.progressOverlayImageLinkedTag ? (
          <div class={'ottWrapper enable expand'}>
            <div class={'ottContainer'}>
              <div class={'ottTemplate'}>
                <div class={'passive-tag-container skin-passive-container'}>
                  <PlayerLayout {...props} tags={props.json && props.json.otags} tag={this.state.progressOverlayImageLinkedTag} isDecisionInput deactivateTag={this.deactivateProgressOverlayImageTag} isExpanded={this.state.overlayImageLinkedTagIsExpanded} isActiveSlide={this.state.overlayImageLinkedTagIsActiveSlide} mapsapi={state.mapsApiLoaded} />
                </div>
              </div>
            </div>
          </div>
        ) : null}
        {this.state.skipDuration && props.isAd && (
          <div onClick={enableSkip ? null : this.handleAdSkip} class={`skip-ad-button ${enableSkip ? '' : 'enable'}`}>
            {enableSkip ? `${this.state.skipDuration - this.state.elapsedTime}` : `Skip Video`}
          </div>
        )}
      </div>
    );
  }

  setVideoEnded = (videoEnded) => {
    this.setState({ videoEnded });
  }

  renderCollectionsMagazine = () => {
    const tag = this.state.tag;
    const details = tag && tag.details;
    const title = details && details.title;
    const attributes = tag && tag.details && tag.details.attributes;

    return (
      <div class={'collections-magazine'}>
        <div class={'collections-magazine__title block-ellipsis'}>{title}</div>
        <MagazineGallery items={attributes} onProdCtaClick={this.handleProdCtaClick} onProdInteraction={this.handleProdGalleryInteraction} />
      </div>
    )
  }

  renderMultiCta = ({ tag, orientation, tagParams }) => {
    return (
      <SkinV3MultiCta
        tag={tag}
        isExpanded={this.props.isExpanded}
        isActiveSlide={this.props.isActiveSlide}
        orientation={orientation}
        onCommerceCtaClick={this.proxyClickHandler}
        refreshSkinLayout={this.refreshSkinLayout}
        logDataEvent={this.props.logDataEvent}
        getCurrentTime={this.props.getCurrentTime}
        customTagParams={tagParams}
      />
    )
  }

  renderProductShowcase = ({ tag, orientation, tagParams }) => {
    return (
      <SkinV3ProductShowcase
        tag={tag}
        isExpanded={this.props.isExpanded}
        isActiveSlide={this.props.isActiveSlide}
        orientation={orientation}
        onCommerceCtaClick={this.proxyClickHandler}
        refreshSkinLayout={this.refreshSkinLayout}
        logDataEvent={this.props.logDataEvent}
        getCurrentTime={this.props.getCurrentTime}
        customTagParams={tagParams}
        meta={this.props.json.meta}
        config_data_json={this.props.json.config_data_json}
      />
    )
  }

  refreshSkinLayout = (tag) => {
    this.setState({ tag }, () => {
      this.props.updateJsonTag(tag);
    })
  }

  renderSkinHotspots = (skinHotspots) => {
    return (skinHotspots.length > 0 && <div class='hotspotsWrapper'>
          {skinHotspots.length > 0}
        </div>)
  }

  renderV2 = (color, title, cta) => {
    if (this.state.isSocialShare) {
      return (
        <div class={`tag-details-wrapper tag-details-share ${this.state.layout}`} style={{ backgroundColor: color }}>
          <div class={`title`} style={{ color: color }}>
            {title}
          </div>
          <SocialShareIcons
            tag={this.state.tag}
            eventBus={this.props.eventBus}
            getCurrentTime={this.props.getCurrentTime}
          />
        </div>
      );
    } else if (this.state.isSocialEmotion) {
      return (
        <div
          class={`tag-details-wrapper tag-details-share emotion ${this.state.layout} ${this.state.tag.emojiSelected ? 'hideEmotionSelection' : ''
            }`}
          style={{ backgroundColor: color }}
        >
          <SocialEmotionIcons
            tag={this.state.tag}
            eventBus={this.props.eventBus}
            getCurrentTime={this.props.getCurrentTime}
            onEmotionIconClick={this.handleEmotionIconClick}
            trackEvent={this.props.trackEvent}
          />
        </div>
      );
    }

    return (
      <div class={`tag-details-wrapper ${this.state.layout}`} style={{ backgroundColor: color }}>
        <h2 class={'tag-details-title'}>{title}</h2>
        <div class={'tag-details-cta'}>
          <button class={'tag-details-cta-button'} style={{ background: color }} onClick={this.proxyClickHandler}>
            {cta}
          </button>
          <i class={'zmdi zmdi-arrow-right'}></i>
        </div>
      </div>
    );
  };

  renderTag = () => {
    const props = this.props;
    const state = this.state;
    const hideCloseTagBtn = !!(props.isFacebookAd || props.noVideo || props.ottOnly) && !!props.deeplinkTagId;
    const tag = this.state.tag;
    const category = tag && tag.settings.category;
    const subcategory =
      category && tag.settings.subcategory && tag.settings.subcategory[0] && tag.settings.subcategory[0].type;
    const layout = this.state.layoutEnabled ? this.state.layout : '';
    const expand = this.state.layoutEnabled ? 'expand' : '';

    const tagParams = this.tagParams && this.tagParams[tag && tag.id];
    const noBackground = tagParams && tagParams.transparent ? 'noBackground' : '';
    const darkTheme = tagParams && (tagParams.theme === 'skins_dark_theme') ? 'darkTheme' : 'lightTheme';

    if (!this.state.tag || (!this.state.image && tagParams && tagParams.skin_launch === 1)) return;
    return (
      <div class={`ottDisplay ${expand} ${layout} ${darkTheme} ${noBackground} tag${subcategory}`}>
        <PlayerLayout
          {...props}
          skinTag={true}
          keyIndex={0}
          index={0}
          tag={state.tag}
          tags={props.json && props.json.otags}
          decisionPointSelector={state.decisionPointSelector}
          isActiveSlide={true}
          isExpanded={true}
          isLandscape={props.orientation === constants.ORIENTATION_LANDSCAPE}
          template={props.json.template}
          hideCloseTagBtn={hideCloseTagBtn}
          mapsapi={props.mapsApiLoaded}
          shouldDeactivateTag={props.deactivateTag}
        />
      </div>
    );
  };

  scratchReady = () => {
    console.log('READY')
    if(window.vpaid) {
      window.vpaid.on('AdStarted', () => {
        console.log('AD Started - scratch pause')
        setTimeout(() => {
          this.props.pauseVideo();
        },0)
      });
    } else {
      this.props.pauseVideo();
    }
  }

  scratchClickEvent = () => {
    this.props.eventBus(constants.LOG_EVENT_CLICK_MANUAL, {
      current_duration: this.props.getCurrentTime(),
      options: { event_type: 'scratch' },
    });
  }

  scratchStart = () => {
    // clearTimeout(this.scratchTimeout);
  }

  scratchDone = () => {
    this.setState({ unloadScratch: true }, () => {
      this.props.playVideo();
    })
  }

  toggleCustomEndcards = (value) => {
    this.setState({ showCustomEndCard: typeof value === 'boolean' ? value : !this.state.showCustomEndCard });
  };

  toggleProgressOverlayImageLinkedTag = (value) => {
    this.setState({ progressOverlayImageLinkedTag: value }, () => {
      setTimeout(() => {
        let storeLocatorInTags = this.props.json.tags.find((item) => item.settings.category === 11);
        let storeLocatorInOtags = this.props.json.otags.find((item) => item.settings.category === 11);
        let isStoreLocatorPresent = storeLocatorInTags || storeLocatorInOtags;
        if (isStoreLocatorPresent) {
          this.setState({ overlayImageLinkedTagIsExpanded: true, overlayImageLinkedTagIsActiveSlide: true});
          this.initializeGoogleMaps();
        }
      }, 300);
    });
  };

  initializeGoogleMaps() {
    if (!window.google && !window.mapsApiLoading) {
      window.mapsApiLoading = true;
      loadJS(links.mapsapi, HEAD).then(() => {
        this.setState({
          mapsApiLoaded: true,
        });
      });
    } else {
      this.setState({
        mapsApiLoaded: true,
      });
    }
  }

  handleReplay = () => {
    this.toggleCustomEndcards();
    this.props.screenReplay();
  };

  triggerSkinLayout = (tagIndex, tag) => {
    let layoutEnabled;

    if (this.meta.skins) {
      if (this.meta && (this.meta.skin_launch === 1 || this.meta.skin_launch === 2)) {
        if (this.state.layoutEnabled && typeof tag === 'undefined') {
          layoutEnabled = true;
          this.setState({
            layoutEnabled,
          });

          return;
        } else if ((!this.state.layoutEnabled && typeof tag === 'undefined') || tag === null) {
          layoutEnabled = false;
        } else if (this.state.layoutEnabled && typeof tag !== 'undefined' && tag !== null) {
          layoutEnabled = true;
        }
      } else {
        layoutEnabled = tag !== null && typeof tag !== 'undefined';

        if (!this.state.startedToPlay) {
          this.setState({
            startedToPlay: true,
          });
        }
      }

      if (typeof tag !== 'undefined' && tag.tag_enabled) {
        this.setLayoutProps(tag, tagIndex, layoutEnabled);
        this.fireSkinDisplayEvent();
      }
    }
  };

  triggerSkinLayoutV2 = (tagIndex, tag) => {
    let layoutEnabled;
    let tagParams = this.tagParams[tag && tag.id];
    if (!tagParams || this.state.closeSkinMode) {
      this.setState({
        layoutEnabled: false,
      });
      return;
    }

    if (this.meta.skins) {
      if (tagParams && (tagParams.skin_launch === 1 || tagParams.skin_launch === 2)) {
        if (this.state.layoutEnabled && typeof tag === 'undefined') {
          layoutEnabled = true;
          this.setState({
            layoutEnabled,
          });

          return;
        } else if ((!this.state.layoutEnabled && typeof tag === 'undefined') || tag === null) {
          layoutEnabled = false;
        } else if (this.state.layoutEnabled && typeof tag !== 'undefined' && tag !== null) {
          layoutEnabled = true;
        }
      } else {
        layoutEnabled = tag !== null && typeof tag !== 'undefined';

        if (!this.state.startedToPlay) {
          this.setState({
            startedToPlay: true,
          });
        }
      }

      if (typeof tag !== 'undefined' && tag.tag_enabled) {
        this.setLayoutProps(tag, tagIndex, layoutEnabled);
        this.fireSkinDisplayEvent();
      }
    }
  };

  setLayoutProps = (tag, tagIndex, layoutEnabled) => {
    let subcategory = tag && tag.settings.subcategory && tag.settings.subcategory[0];
    let isShowcase = subcategory && (subcategory.type === 1401 || subcategory.type === 1403);
    let isSocialShare = subcategory && subcategory.type === 1601;
    let isSocialEmotion = subcategory && subcategory.type === 1602;
    let engagement = tag.details && tag.details.engagements && tag.details.engagements[0];
    let images = isShowcase ? engagement && engagement.meta : tag && tag.media.images;
    let imageCount = isShowcase ? images.length : this.getImageCount(images);
    let image = tag && this.getImage(this.props.orientation);
    let settingsEngagement = subcategory && subcategory.engagements && subcategory.engagements[0];
    let cta = settingsEngagement && settingsEngagement[`label|${settingsEngagement.slug}`];
    let ctaValue = settingsEngagement && settingsEngagement[`value|${settingsEngagement.slug}`];

    const updatedTimeStamp = tag && tag.updatedTagData && tag.updatedTagData.timeStamp;
    const currTimeStamp = this.state.tag && this.state.tag.updatedTagData && this.state.tag.updatedTagData.timeStamp;

    if (
      layoutEnabled !== this.state.layoutEnabled ||
      tagIndex !== this.state.tagIndex ||
      (tag && tag.id) !== (this.state.tag && this.state.tag.id) ||
      image !== this.state.image ||
      updatedTimeStamp && updatedTimeStamp !== currTimeStamp && updatedTimeStamp > currTimeStamp
    ) {
      this.setState({
        layoutEnabled,
        tagIndex,
        tag,
        isShowcase,
        isSocialShare,
        isSocialEmotion,
        engagement,
        images,
        imageCount,
        image,
        cta,
        ctaValue,
      });
    }
  };

  setTranslate = (prevState) => {
    if (prevState && this.state.layoutEnabled === prevState.layoutEnabled) return;
    if (this.state.layoutEnabled) {
      this.setState(
        {
          scaleOut: true,
        },
        () => {
          setTimeout(() => {
            this.swiperWrapper.style.transform = `translate3d(0px, 0px, 0px) rotateX(0deg) rotateY(-60deg)`;
          }, 500);
        }
      );
    } else {
      this.setState(
        {
          scaleOut: false,
        },
        () => {
          this.swiperWrapper.style.transform = `translate3d(0px, 0px, 0px) rotateX(0deg) rotateY(0deg)`;
        }
      );
    }
  };

  handleImageClick = (e) => {
    let target = e.target;
    let isScreenController = target.classList.contains('screenControllerBg');
    if (isScreenController) {
      this.proxyClickHandler(e);
    }

    return false;
  };

  setTagInScreenController = (tag) => {
    let subcategory = tag && tag.settings && tag.settings.subcategory && tag.settings.subcategory[0];
    let collectionsVideoActiveIdxMap = {...(this.state.collectionsVideoActiveIdxMap || {})};
    const isCollectionsVideo = subcategory && subcategory.type === 107;
    if (isCollectionsVideo && collectionsVideoActiveIdxMap[tag.id] === undefined) {
      collectionsVideoActiveIdxMap[tag.id] = 0;
    }
    if (isCollectionsVideo) {
      this.setState({ tag, collectionsVideoActiveIdxMap });
    }
  }

  handleActiveProdVideo = (idx) => {
    const tag = this.state.tag;
    const tagid = tag && tag.id;
    if (!tagid) {
      return;
    }
    const syncVideos = tag && tag.details && tag.details.productImageTypePreview;
    const prevIdx = this.state.collectionsVideoActiveIdxMap[tagid];
    this.setState({
      collectionsVideoActiveIdxMap: { ...this.state.collectionsVideoActiveIdxMap, [tagid]: idx }
    }, () => {
      let currentTime = 0;
      if (typeof prevIdx === 'number') {
        currentTime = this.videoPlayer[prevIdx].getCurrentTime();
      }
      this.videoPlayer.forEach((item) => {
        item.pause();
      });
      if (syncVideos) {
        this.videoPlayer[idx].setCurrentTime(currentTime)
      }
      this.videoPlayer[idx].play()
    })
  }

  handleProdCtaClick = (item) => {
    const link = item && item.details && item.details.cta;
    let ctaTrackers = item && item.details && item.details.ctaTracker || '';
    ctaTrackers = ctaTrackers.split('||');
    if (ctaTrackers.length > 0) {
      ctaTrackers.forEach(tracker => {
        if (tracker) {
          addPixelImage(tracker);
        }
      });
    }
    window.open(link, '_blank');
    this.fireOutVideoEvent({
      event_type: 'collection_product',
      engagement_id: item && item.id,
      engagement_label: item && item.details && item.details.title
    });
  }

  handleProdGalleryInteraction = (product) => {
    const tag_label = product && product.details && product.details.title;
		const engagement_id = product && product.id;
		const engagement_data = parseJsonToFormData({ product_id: engagement_id, product_label: tag_label });
		this.props.eventBus(constants.LOG_EVENT_GALLERY_INTERACTION, {
			tag: this.props.tag,
			duration: this.props.getCurrentTime(),
			event_type: 'collection_product',
			engagement_data,
			engagement_id,
			tag_label,
			engagement_label: tag_label,
		});
  }

  handlePlay = (tagIndex, tag, e) => {
    this.setState({
      startedToPlay: true,
    });

    setTimeout(
      () => {
        if (this.meta.skins) {
          this.setLayoutProps(tag, tagIndex, true);
          this.fireSkinDisplayEvent();
        }
      },
      this.meta.skin_launch === 1 ? 0 : 4000
    );
  };

  setSquareVideo = (isSquareVideo) => {
    this.setState({
      isSquareVideo,
    }, () => {
      this.props.setSquareVideo(isSquareVideo)
    });
  };

  handleShowcaseLink = (item, e) => {
    if (item.ctaUrl && item.ctaUrl !== '') {
      let url = item.ctaUrl;

      if (!/^(http|https):\/\//.test(url)) {
        url = `http://${url}`;
      }

      // window.open(url, '_blank');
      // OneAd clickThru---
      handleExternalLinksViaClickThru(url, this.props.creativeData);
      //---
      this.fireOutVideoEvent();
    } else this.proxyClickHandler.call(this, e);
  };

  handleGoBackToVideo = (e) => {
    this.setState(
      {
        disableAnimation: true,
      },
      () => {
        this.swiper && this.swiper.slideTo(0, 0.1);
        this.setState({
          disableAnimation: false,
        });
      }
    );
  };

  handleEmotionIconClick = (tag, emojiSelected) => {
    // this.setState({ emojiSelected: { ...this.state.emojiSelected, [tag.id]: emojiSelected } });
    const updatedTag = { ...tag, emojiSelected };
    this.props.updateJsonTag(updatedTag);
  };

  proxyClickHandler = (e, eventData={}) => {
    if (e) e.stopPropagation();

    let tag = this.state.tag;
    const tagParams = this.tagParams && this.tagParams[tag && tag.id];
    const isSkinsV2 = tagParams && tagParams.skin_version === 'v4';

    if (isSkinsV2) return;

    if (typeof tag !== 'undefined') {
      let category = tag.settings.category;
      let subcategory = tag.settings.subcategory && tag.settings.subcategory[0];

      switch (category) {
        case 1:
        case 7:
        case 8:
        case 10:
        case 16:
          // handle out-video tags
          let engagement = subcategory.engagements && subcategory.engagements[0];
          let url = engagement && engagement[`value|${engagement.slug}`];

          if (category === 10) {
            let playStoreLink = engagement && engagement[`linkplaystore|${engagement.slug}`];
            let appStoreLink = engagement && engagement[`linkappstore|${engagement.slug}`];
            let deviceType = getMobileOS();

            if (deviceType === 'Android' && playStoreLink) url = playStoreLink;
            else if (deviceType === 'iOS' && appStoreLink) url = appStoreLink;
          }

          if (!/^(http|https):\/\//.test(url)) {
            url = `http://${url}`;
          }

          // window.open(url, '_blank');
          // OneAd clickThru---
          handleExternalLinksViaClickThru(url, this.props.creativeData);
          //---
          this.fireOutVideoEvent(eventData);
          return false;

        case 9:
        case 11:
        case 12:
        case 14:
        case 15:
          // handle in-video tags
          this.props.renderTag(this.state.tagIndex);
          this.fireInVideoEvent();
      }
    }
  };

  getImageFromTag = (tag, orientation) => {
    let isLandscape = orientation === constants.ORIENTATION_LANDSCAPE;
    if (tag && tag.media && tag.media.images) {
      const img1 = getLinkedTagImage({ images: tag.media.images }, 'img1', null, null, true);
      const img2 = getLinkedTagImage({ images: tag.media.images }, 'img2', null, null, true);
      return (
        tag &&
        (isLandscape
          ? img1
          : typeof img2 !== 'undefined'
          ? img2
          : img1)
      );
    }
  };

  getImage = (orientation, attrTag) => {
    let tag = attrTag || this.state.tag;
    if (tag) {
      let subcategory = tag && tag.settings.subcategory && tag.settings.subcategory[0];
      switch (tag.settings.category) {
        case 1:
        case 7:
        case 8:
        case 10:
        case 11:
        case 12:
        case 15:
        case 16:
        case 18:
        case 19:
        case 20:
          return this.getImageFromTag(tag, orientation);
        case 9:
          switch (subcategory.type) {
            case 900:
              let engagement = tag.details && tag.details.engagements && tag.details.engagements[0];
              let answers = engagement && engagement && engagement.answer;
              if (engagement && engagement.imagepoll) {
                return answers && answers[0].image;
              } else return this.getImageFromTag(tag, orientation);
            case 901:
            case 902:
            case 904:
            case 905:
            case 906:
              return this.getImageFromTag(tag, orientation);
          }
        case 14:
          switch (subcategory.type) {
            case 1402:
              return this.getImageFromTag(tag, orientation);
            case 1401:
            case 1403:
              let engagement = tag.details && tag.details.engagements && tag.details.engagements[0];
              let firstGallaryElem = engagement.meta && engagement.meta[0];
              if (firstGallaryElem) {
                return firstGallaryElem.cover_image_selected || firstGallaryElem.url;
              }
          }
        case 21:
          switch (subcategory.type) {
            case 2104:
              let engagement = tag.details && tag.details.engagements && tag.details.engagements[0];
              let answers = engagement && engagement && engagement.answer;
              if (engagement && engagement.imagepoll) {
                return answers && answers[0].image;
              } else return this.getImageFromTag(tag, orientation);
            case 2101:
            case 2102:
            case 2103:
              return this.getImageFromTag(tag, orientation);
          }
      }
    }
  };

  getImageCount = (imagesArr = []) => {
    let i = 1;
    let count = 0;

    while (imagesArr && imagesArr[`img${i}_src`]) {
      count = i;
      i++;
    }

    return count;
  };

  getImageIndex = (images, index) => {
    if (this.state.isShowcase) {
      let tag = this.state.tag;
      let meta = tag && tag.details.engagements && tag.details.engagements[0] && tag.details.engagements[0].meta;
      return meta[index];
    } else {
      return getLinkedTagImage({ images }, `img${index + 1}`, null, null, true) || images[`img${index + 1}_src`];
    }
  };

  getSkinLayout = () => {
    const tag = this.state.tag;
    const tagParams = tag && this.tagParams[tag.id];
    const skinVersion = tagParams && tagParams.skin_version;
    const skinOrientation = this.meta && this.meta.skin_orientation;

    const customProportions = tagParams && tagParams.config && tagParams.config.customProportions && tagParams.config.customProportions;
    if (customProportions && customProportions.isEnabled) {
      let scaledWidth = `${((customProportions.width / customProportions.containerWidth) * window.innerWidth)}px`;
      let scaledHeight = `${((customProportions.height / customProportions.containerHeight) * window.innerHeight)}px`;
      const movementFromLeft = ((window.innerWidth / customProportions.containerWidth) * customProportions.x);
      const movementFromTop = ((window.innerHeight / customProportions.containerHeight) * customProportions.y);
      if (customProportions.width / customProportions.containerWidth >= 0.99) scaledWidth = '100%';
      if (customProportions.height / customProportions.containerHeight >= 0.99) scaledHeight = '100%';
      this.screenHandleRef.style.setProperty('--custom-proportions-width', `${scaledWidth || '100%'}`);
      this.screenHandleRef.style.setProperty('--custom-proportions-height', `${scaledHeight || '100%'}`);
      this.screenHandleRef.style.setProperty('--custom-proportions-left', `${movementFromLeft || 0}px`);
      this.screenHandleRef.style.setProperty('--custom-proportions-top', `${movementFromTop || 0}px`);
      return 'skinHasCustomProportions';
    }

    if (this.meta) {
      if (skinVersion === 'v3') return 'skincube';
      switch (skinOrientation) {
        case 'left':
          return 'skinLt';
        case 'right':
          return 'skinRt';
        case 'center':
          return 'skinCt';
        case 'top':
          return 'skinTp';
        case 'bottom':
          return 'skinBtm';
      }
    } else return null;
  };

  getSkinConnectedAssetsLayoutClasses = (videoSize, forVideo) => {
    const skinOrientation = this.meta && this.meta.skin_orientation;
    let assetsLayoutClass = '';
    let connVidClass = '';
    if (this.meta) {
      switch (skinOrientation) {
        case 'left':
          assetsLayoutClass = 'skinConnAstsRight';
          connVidClass = 'connVidLt';
          break;
        case 'right':
          assetsLayoutClass = 'skinConnAstsLeft';
          connVidClass = 'connVidRt';
          break;
        // case 'center':
        //   assetsLayoutClass = 'skinCt';
        //   break;
        case 'top':
          assetsLayoutClass = 'skinConnAstsBtm';
          connVidClass = 'connVidTop';
          break;
        case 'bottom':
          assetsLayoutClass = 'skinConnAstsTop';
          connVidClass = 'connVidBtm';
          break;
      }
    }

    let assetsGridSizeClass = '2by2';
    let vidSizeClass = '';
    if (videoSize === 'small') {
      vidSizeClass = 'vidSizeSmall';
    } else if (videoSize === 'medium') {
      vidSizeClass = 'vidSizeMedium';
    } else if (videoSize === 'large') {
      vidSizeClass = 'vidSizeLarge';
      assetsGridSizeClass = '1by1';
    }

    if (forVideo) return ` ${connVidClass} ${vidSizeClass} `;

    return ` ${assetsLayoutClass} ${videoSize + assetsGridSizeClass} `;
  };

  getSkinSliderLayoutClasses = (videoSize) => {
    const skinOrientation = this.meta && this.meta.skin_orientation;
    let skinSliderClass = '';
    let connVidClass = '';
    if (this.meta) {
      switch (skinOrientation) {
        case 'left':
          skinSliderClass = 'skinSliderInRight';
          break;
        case 'right':
          skinSliderClass = 'skinSliderInLeft';
          break;
      }
    }

    let vidSizeClass = '';
    if (videoSize === 'small') {
      vidSizeClass = 'vidSizeSmall';
    } else if (videoSize === 'medium') {
      vidSizeClass = 'vidSizeMedium';
    } else if (videoSize === 'large') {
      vidSizeClass = 'vidSizeLarge';
    }

    return ` ${skinSliderClass} ${vidSizeClass} `;
  }

  handleSkinConnectedAssetClick = (type, sourceCat, id, cltTracker='') => {
    if (type === 'video' && sourceCat === 15 && id) {
      this.props.pauseVideo();
      this.setState({ initializeConnectedVideo: id }, () => {
        const cltTrackers = cltTracker.split('||');
        if (cltTrackers.length > 0) {
          cltTrackers.forEach(tracker => {
            if (tracker) {
              addPixelImage(tracker);
            }
          });
        }
      });
    }
  };

  handleSkinConnectedAssetClose = () => {
    this.setState({ initializeConnectedVideo: null });
  }

  initializeSlider = () => {
    this.swiper = new Swiper(this.swiperContainer, {
      speed: 100,
      effect: 'cube',
      grabCursor: true,
      virtualTranslate: true,
      cubeEffect: {
        shadow: false,
        slideShadows: false,
      },
      navigation: {
        nextEl: this.swiperNaviRight,
        prevEl: this.swiperNaviLeft,
      },
      on: {
        touchMove: (event) => {
          this.setState({
            scaleOut: true,
          });
        },
        touchEnd: (event) => {
          this.setState({
            scaleOut: false,
          });
        },

        slideChange: (event) => {
          if (this.state.images && this.state.images.length > 0) {
            let nonVideoPlayerItems = 1; // 1, 'cause first slide is the main video
            for (let i = 0; i < this.state.images.length; i++) {
              const item = this.state.images[i];
              if (item.type !== 'video') {
                nonVideoPlayerItems++;
                continue;
              }

              this.videoPlayer.forEach((item, index) => {
                item.pause();
              });
              if (this.videoPlayer[this.swiper.activeIndex - nonVideoPlayerItems]) {
                this.videoPlayer[this.swiper.activeIndex - nonVideoPlayerItems].play();
              }
            }
          }
          if (this.swiper.activeIndex === 0) {
            this.props.playVideo();
            this.setState({
              activeIndex: this.swiper.activeIndex,
              enableLoopBack: false,
            });
          } else {
            this.props.pauseVideo();
            this.setState({
              activeIndex: this.swiper.activeIndex,
              enableLoopBack: false,
            });
          }
        },
      },
    });
  };

  prevSlide = () => {
    this.setState(
      {
        scaleOut: true,
      },
      () => {
        setTimeout(() => {
          setTimeout(() => {
            this.setState({
              scaleOut: false,
            });
          }, 400);

          this.toggleLoopBack();
          this.fireClickEvent();
        }, 100);
      }
    );
  };

  nextSlide = (e) => {
    this.setState(
      {
        scaleOut: true,
      },
      () => {
        setTimeout(() => {
          setTimeout(() => {
            this.setState({
              scaleOut: false,
            });
          }, 400);

          if (this.state.enableLoopBack) {
            this.swiper.slideTo(0);
          }

          this.toggleLoopBack();
          this.fireClickEvent();
        }, 100);
      }
    );
  };

  toggleLoopBack = () => {
    if (this.swiper.activeIndex + 1 === this.swiper.slides.length) {
      this.setState({
        enableLoopBack: true,
      });
    } else {
      this.setState({
        enableLoopBack: false,
      });
    }
  };

  fireClickEvent = () => {
    let tag = this.state.tag;
    let clickEvent = constants.LOG_EVENT_CLICK_MANUAL;

    this.props.eventBus(clickEvent, {
      tag,
      current_duration: this.props.getCurrentTime(),
    });
  };

  fireOutVideoEvent = (options = {}, linkedTag) => {
    let tag = this.state.tag;
    if (!tag && linkedTag) tag = linkedTag;

    this.props.eventBus(constants.LOG_EVENT_ENGAGEMENT, { tag, engagement_type: 'out-video', options });
    this.props.eventBus(constants.LOG_EVENT_INTERACTION, {
      tag,
      current_duration: this.props.getCurrentTime(),
    });
  };

  fireInVideoEvent = (linkedTag) => {
    let tag = this.state.tag;
    if (!tag && linkedTag) tag = linkedTag;

    this.props.eventBus(constants.LOG_EVENT_INTERACTION, {
      tag,
      current_duration: this.props.getCurrentTime(),
    });
  };

  fireSkinDisplayEvent = () => {
    const tag = this.state.tag;
    const tagParams = this.tagParams && this.tagParams[tag && tag.id];
    const skin_version = tagParams && tagParams.skin_version;
    const skin_launch = tagParams && tagParams.skin_launch;

    if (tag && !this.skinmap.tags[tag.id]) {
      this.props.logDataEvent({
        event: 'display',
        event_type: `skin:${this.skinmap[skin_version]}:${this.skinmap[`launch${skin_launch}`]}`,
        tag_id: tag && tag.id,
        tag_label: (tag && tag.details.preview_title) || tag.details.title || '',
      });

      this.skinmap.tags[tag.id] = true;
    }
  };

  disableSkinMode = () => {
      this.setState({
          closeSkinMode: true,
          layoutEnabled: false
      })
  }

  handleSkinHotspotClick = (item) => {
    let { url, tracker, id, title, isTagConnected, tagId } = item;
    const {enableOnSkinSlider, onSkinSliderImage} = item;
    if (isTagConnected) {
      const currTagIdx = tagId && this.props.json.otags.findIndex(t => t.id === tagId);
      const selectedTag = this.props.json.otags[currTagIdx];
      if (selectedTag) {
        this.setState({ hotspotLinkedTag: selectedTag }, () => {
          if (!isSkipEnabled(selectedTag, this.props.creativeData)) {

            setTimeout(() => {
              let storeLocatorInTags = this.props.json.tags.find((item) => item.settings.category === 11);
              let storeLocatorInOtags = this.props.json.otags.find((item) => item.settings.category === 11);
              let isStoreLocatorPresent = storeLocatorInTags || storeLocatorInOtags;
              if (isStoreLocatorPresent) {
                this.initializeGoogleMaps();
              }
            }, 300);

            this.fireInVideoEvent();
            this.props.pauseVideo();
          } else {
            const network = this.props.creativeData && this.props.creativeData.network;
            const clickThru = network && constants.CLICKTHRU_NETWORKS.includes(network);
            if (!clickThru) {
              this.fireOutVideoEvent({
                event_type: 'skinhotspot',
                engagement_id: id,
                engagement_label: title
              });
            }
          }
        })
      }
    } else if (enableOnSkinSlider && Object.keys(onSkinSliderImage).length > 0) {
      this.setState({
        animateInSkinSliderId: id,
      });
      this.fireInVideoEvent();
    } else {
      // window.open(url, "_blank");
      // OneAd clickThru---
      handleExternalLinksViaClickThru(url, this.props.creativeData);
      //---
      const network = this.props.creativeData && this.props.creativeData.network;
      const clickThru = network && constants.CLICKTHRU_NETWORKS.includes(network);
      if (!clickThru) {
        this.fireOutVideoEvent({
          event_type: 'skinhotspot',
          engagement_id: id,
          engagement_label: title
        });
      }
    }
    if (tracker) {
      addPixelImage(tracker)
    }
  }

  handleSkinSliderClick = ({onSkinSliderCtaLink: url, id, title}) => {
    // OneAd clickThru---
    handleExternalLinksViaClickThru(url, this.props.creativeData);
    //---
    this.fireOutVideoEvent({
      event_type: 'skinhotspot',
      engagement_id: id,
      engagement_label: title
    });
  }

  handleSkinSliderCloseClick = (e) => {
    e && e.stopPropagation();
    this.setState({
      animateInSkinSliderId: 0,
    });
  }

  deactivateHotspotTag = (e) => {
    e && e.stopPropagation();
    this.setState({ hotspotLinkedTag: null });
    this.props.deactivateTag();
  }

  deactivateProgressOverlayImageTag = (e) => {
    e && e.stopPropagation();
    this.setState({ progressOverlayImageLinkedTag: null, overlayImageLinkedTagIsExpanded: false, overlayImageLinkedTagIsActiveSlide: false,mapsApiLoaded: false });
    this.props.deactivateTag();
  }

  destroySliderTile = () => {
    if (this.swiperTile) {
      this.swiperTile.off('slideChangeTransitionEnd', this.handleTileSlideChange);
      this.swiperTile.destroy();
    }
  }

  initializeSliderTile = () => {
    if (this.state.swiperJsTile && this.swiperContainerTile) {
      this.destroySliderTile();

      this.swiperTile = new Swiper(this.swiperContainerTile, {
        speed: 100,
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 10,
        noSwiping: true,
        allowTouchMove: false,
      });
      this.swiperTile.on('slideChangeTransitionEnd', this.handleTileSlideChange);
      this.setSliderArrows();
      this.setTileDimensionClass();
      this.setState({ currentTileIndex: 0 }, () => {
        this.swiperTile && this.swiperTile.slideTo(this.state.currentTileIndex);
      });
    }
  };

  toggleTileProducts = (show, tag, tileProducts) => {
    if (!show && !this.state.showTileProducts) return;
    this.setState({
      showTileProducts: !!show,
      tileProducts,
      tileLinkedTag: tag,
      animateInTiles: '',
      animateScreenShrink: !!show,
    }, () => {
      if (this.state.showTileProducts) {
        // hides tag preview in mobile mode, via player/index.js
        this.props.tileModeStatus(true);

        this.initializeSliderTile();
        if (isMiniature()) {
          this.props.pauseVideo();
          this.setState({ currentTileIndex: 1 }, () => {
            this.swiperTile && this.swiperTile.slideTo(this.state.currentTileIndex);
          });
        }

        // animate tiles entry from below
        setTimeout(() => {
          this.setState({ animateInTiles: 'animateInTiles' });
          if (this.props.isMobileDevice && this.props.orientation === constants.ORIENTATION_PORTRAIT) {
            // for mobile devices, calculate tile height
            const screenWrapperElement = this.swiperWrapperTile && this.swiperWrapperTile.querySelector('.screenWrapper');
            if (screenWrapperElement && this.props.videoWidth > this.props.videoHeight) {
              this.setState({ slideTileHeight: screenWrapperElement.offsetHeight });
            }
          }
        }, 200);

        // animate screen shrink to it's position
        setTimeout(() => {
          this.setState({ animateScreenShrink: false });
        }, 900);
        this.setTileDimensionClass();
      } else {
        this.destroySliderTile();
        this.props.tileModeStatus(false);
        this.setState({ animateScreenShrink: false });
      }
    });
  }

  setTileDimensionClass = () => {
    // this.state.tileDimensionClass
    // only in a vertical video in mobile size, would the scroll be vertical, else horizontal always
    const playerIsAtEmbedSize = isMiniature();
    if (playerIsAtEmbedSize) {
      this.setState({ tileDimensionClass: 'tile1By1' });
      // player would need horizontal scroll via swiper
    } else {
      // 2by2
      this.setState({ tileDimensionClass: 'tile2By2' });
    }
  }

  handleTileClick = (e) => {
    const id = e && e.target && e.target.id;
    const prodId = Number(id.split('_')[0]);
    let selectedProd =
      this.state.tileLinkedTag
      && this.state.tileLinkedTag.details
      && this.state.tileLinkedTag.details.attributes
      && this.state.tileLinkedTag.details.attributes.length > 0
      && this.state.tileLinkedTag.details.attributes.filter(p => p.id === prodId);
    if (selectedProd && selectedProd.length > 0) selectedProd = selectedProd[0];
    if (selectedProd && selectedProd.details && selectedProd.details.skipDetails) {
      let url = selectedProd.details.cta;

      if (!/^(http|https):\/\//.test(url)) {
        url = `http://${url}`;
      }

      // window.open(url, '_blank');
      // OneAd clickThru---
      handleExternalLinksViaClickThru(url, this.props.creativeData);
      //---
      this.fireOutVideoEvent({
        event_type: 'collection_product',
        engagement_id: selectedProd.id,
        engagement_label: selectedProd.details.title
      }, this.state.tileLinkedTag);
      return;
    }
    const updatedTag = {
      ...this.state.tileLinkedTag,
      selectedProdIndex: Number(id.split('_')[1]) || 0,
    };
    this.props.updateJsonTag(updatedTag);
    let toggleLock = false;
    if (this.state.editorMode) toggleLock = true;
    const currTagIdx = updatedTag && updatedTag.id && this.props.json.otags.findIndex(t => t.id === updatedTag.id);

    const tag_label = selectedProd && selectedProd.details && selectedProd.details.title;
    const engagement_id = selectedProd && selectedProd.id;
    const engagement_data = parseJsonToFormData({ product_id: engagement_id, product_label: tag_label });

    let eventData = {
      tag: this.state.tileLinkedTag,
      current_duration: this.props.getCurrentTime(),
      engagement_data
    }
    this.props.eventBus(constants.LOG_EVENT_INTERACTION, eventData);

    // this.fireInVideoEvent(this.state.tileLinkedTag);
    this.props.renderTag(currTagIdx, toggleLock, true);
  };

  nextTileGroup = (e) => {
    this.setState({ currentTileIndex: this.state.currentTileIndex + 1 }, () => {
      this.swiperTile && this.swiperTile.slideTo(this.state.currentTileIndex);
    });
    e && e.stopPropagation();
  };

  prevTileGroup = (e) => {
    this.setState({ currentTileIndex: this.state.currentTileIndex - 1 }, () => {
      this.swiperTile && this.swiperTile.slideTo(this.state.currentTileIndex);
    });
    e && e.stopPropagation();
  };

  setSliderArrows = () => {
    if (this.swiperTile) {
      const { isEnd, isBeginning } = this.swiperTile;
      this.setState({
        isBeginningTile: isBeginning,
        isEndTile: isEnd,
      }, () => {
        setTimeout(() => {
          this.setState({ animateTileNav: true });
        }, 500);
      });
    }
  }

  handleTileSlideChange = (e) => {
    e && e.stopPropagation();
    this.setSliderArrows();
  }

  handleResize = () => {
    this.initializeSliderTile();
  }

  isTileThemeEnabled = (tags) => {
    let isTileThemeEnabled = false;
    if (tags && tags.length > 0) {
      for (let i = 0; i < tags.length; i++) {
        const tag = tags[i];
        isTileThemeEnabled = tag && tag.details && tag.details.customTheme === 'tiles';
        if (isTileThemeEnabled) break;
      }
    }
    return isTileThemeEnabled;
  }

  handleCustomProportionsWhenResize = () => {
    this.setState({
      layout: this.getSkinLayout(),
    });
  };
}



// WEBPACK FOOTER //
// ./components/screenController/index.js